'use client';

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQueryBelow } from '@svs/ui/media-query/react';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@svs/ui/react/sheet';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useTransition } from 'react';
/**
 * Renders a sheet base for tipsen products.
 *
 * @param root0 input props.
 * @param root0.children the children to pass down
 * @param root0.isOpen True to open the sheet
 * @param root0.isLocked Prevent closing when true (content still loading)
 * @param root0.side the side the sheet should be rendered on
 * @param root0.title the title shown in the sheet header
 * @param root0.description the screen-reader description for the sheet
 * @param root0.onOpenChange callback to run when sheet is opened/closed
 * @returns Sheet component with some
 */
export default function TipsenSheet(t0) {
  const $ = _c(13);
  const {
    children,
    isOpen,
    isLocked,
    side,
    title,
    description,
    onOpenChange: onOpenChangeProp
  } = t0;
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const [isNavigating, startTransition] = useTransition();
  const isSmallDevice = useMediaQueryBelow("sm");
  let t1;
  if ($[0] !== isNavigating || $[1] !== onOpenChangeProp || $[2] !== pathname || $[3] !== router || $[4] !== searchParams) {
    t1 = isOpened => {
      if (isOpened) {
        onOpenChangeProp?.(isOpened);
        return;
      }
      onOpenChangeProp?.(isOpened);
      if (!searchParams.has("sheet") || isNavigating) {
        return;
      }
      const qs = new URLSearchParams(searchParams);
      qs.delete("sheet");
      const newPath = qs.toString() ? `${pathname}?${qs.toString()}` : pathname;
      startTransition(() => {
        router.replace(newPath, {
          scroll: false
        });
      });
    };
    $[0] = isNavigating;
    $[1] = onOpenChangeProp;
    $[2] = pathname;
    $[3] = router;
    $[4] = searchParams;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const onOpenChange = t1;
  const t2 = isLocked ? undefined : onOpenChange;
  const t3 = side ?? isSmallDevice ? "bottom" : "right";
  let t4;
  if ($[6] !== children || $[7] !== description || $[8] !== isOpen || $[9] !== t2 || $[10] !== t3 || $[11] !== title) {
    t4 = _jsx(Sheet, {
      open: isOpen,
      onOpenChange: t2,
      children: _jsxs(SheetContent, {
        side: t3,
        className: "flex flex-col rounded-t-lg",
        children: [_jsx(SheetHeader, {
          className: "mb-4",
          children: _jsx(SheetTitle, {
            children: title
          })
        }), _jsx(SheetDescription, {
          className: "sr-only",
          children: description
        }), children]
      })
    });
    $[6] = children;
    $[7] = description;
    $[8] = isOpen;
    $[9] = t2;
    $[10] = t3;
    $[11] = title;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}